import styled from 'styled-components'

const TagsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 20px 0;
  padding: 0;

  @media (max-width: 800px) {
    padding: 0;
    margin: 16px 0;
    gap: 8px;
  }
`

const Tag = styled.div`
  background: #f2f7fe;
  border-radius: 6px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 31px;
  box-sizing: border-box;

  @media (max-width: 800px) {
    padding: 6px 12px;
    min-height: 27px;
  }
`

const TagText = styled.span`
  color: #212d40;
  font-size: 14px;
  font-family: 'Helvetica Neue', Arial, sans-serif;
  font-weight: 400;
  letter-spacing: 0.28px;
  line-height: 1;
  text-align: center;
  white-space: nowrap;

  @media (max-width: 800px) {
    font-size: 12px;
    letter-spacing: 0.24px;
  }
`

export const Tags = ({ notableObjects = [] }) => {
  if (!notableObjects || notableObjects.length === 0) {
    return null
  }

  return (
    <TagsContainer>
      {notableObjects.map((tag, index) => (
        <Tag key={index}>
          <TagText>{tag}</TagText>
        </Tag>
      ))}
    </TagsContainer>
  )
}
